<template>
	<div>
	

		<b-row class="mt-5">

			<b-col md="4">

				<b-form
					inline
					@submit.prevent="searchContacts"
				>

					<b-form-group>
						<b-input
							type="text"
							v-model="currentSearch"
						/>

						<b-button
							type="submit"
							variant="outline-success"
						>Search</b-button>

						<b-button
							v-if="searchFlag"
							@click.prevent="clearSearch"
							variant="outline-danger"
						>Clear</b-button>

					</b-form-group>

				</b-form>

			</b-col>

			<b-col>
				<b-link
					:to="{ name: 'contactcreate' }"
					class="float-right  mb-3"
					
					title="Add a new Contact"
				>
					<b-icon font-scale="1.5" icon="plus-square"></b-icon>
				</b-link>

			</b-col>

		</b-row>

		<b-row class="mt-1">

			<b-col md="12">

				<b-table-simple bordered>

					<b-thead head-variant="light">
						<tr>

							<th>
								<a
									href="#"
									@click.prevent="sort('Name')"
								>
									Name
									<b-icon font-scale="1.5" class="ml-3"
										v-if="currentSort=='Name' && currentSortDir=='asc'"
										icon="chevron-compact-up"
									></b-icon>
									<b-icon font-scale="1.5" class="ml-3"
										v-else-if="currentSort=='Name' && currentSortDir=='desc'"
										icon="chevron-compact-down"
									></b-icon>
									<b-icon font-scale="1.5" class="ml-3"
										v-else
										icon="arrow-up-down"
									></b-icon>
								</a>
							</th>

							<th>Added</th>
							<th>Updated</th>

						</tr>
					</b-thead>
					<b-tbody>
						<contact-list-row
							v-for="contact in contacts"
							:key="contact.Id"
							:contact="contact"
							@update="updateContact"
						/>
					</b-tbody>
				</b-table-simple>

			</b-col>
		</b-row>

		<!-- <b-row class="mt-3">

		
			<b-col cols="4" offset="4">			
				<b-pagination first-number last-number v-model="paging.currentPage" :total-rows="paging.totalCount" :per-page="paging.pageSize" @input="fetchContacts" limit="6" align="fill"></b-pagination> 
			</b-col>

			<b-col cols="1">
				<b-form-input debounce="1000" min="1" v-model="paging.currentPage" :max="paging.totalPages" type="number" @input="fetchContacts"></b-form-input>				
			</b-col>


		</b-row> -->

		<div class="d-flex justify-content-center mb-5">
			<b-pagination
				first-number
				last-number
				v-model="paging.currentPage"
				:total-rows="paging.totalCount"
				:per-page="paging.pageSize"
				@input="fetchContacts"
				limit="7"
				class="mr-3"
			></b-pagination> 
			<b-form-input
				debounce="1000"
				min="1"
				v-model="paging.currentPage"
				:max="paging.totalPages"
				type="number"
				@input="fetchContacts"
				style="width:100px;"
			></b-form-input>
		</div>
		

	</div>
</template>


<script>
import ContactService from '@/api-services/contact.service';
import ContactListRow from '@/components/contact/contact-list-row';

export default {
	name: 'ContactList',

	components: {
		ContactListRow,
	},

	data() {
		return {
			contacts: [],
			selectedContactId: null,

			currentSort: 'Name',
			currentSortDir: 'asc',

			currentSearch: '',
			searchFlag: false,

			paging: {
				currentPage:
					this.$route.query.p == null
						? 1
						: parseInt(this.$route.query.p),
				pageSize: 50,
				totalCount: 999,
				totalPages: 30
			},

			tabIndex: 1,
		};
	},


	created() {
		this.urlReadState();
	},


	methods: {
		sort(s) {
			//if s == current sort, reverse
			if (s === this.currentSort) {
				this.currentSortDir =
					this.currentSortDir === 'asc' ? 'desc' : 'asc';
			}
			this.currentSort = s;
			this.fetchContacts();
		},

		updateContact(contactId) {
			this.$router.push({
				name: 'contactupdate',
				params: { id: contactId },
			});
		},

		resetPaging() {
			this.paging = {
				currentPage: 1,
				pageSize: 50,
				totalCount: 0,
				totalPages: 0,
			};
		},

		urlReadState() {
			let urlSort = this.$route.query.s;
			let urlSortDir = this.$route.query.d;
			let urlSearch = this.$route.query.q;

			if (urlSort || urlSortDir) {
				this.currentSortDir = (urlSortDir === undefined) ? '' : urlSortDir;
				this.currentSort = (urlSort === undefined) ? this.currentSort : urlSort;
			}

			if (urlSearch) {
				this.currentSearch = (urlSearch === undefined) ? '' : urlSearch;
				this.searchContacts();
			} else {
				this.fetchContacts();
			}

		},

		urlPushState() {
			if (history.pushState) {

				const urlParams = new URLSearchParams(window.location.search);

				if (this.paging.currentPage > 1) {
					urlParams.set('p', this.paging.currentPage);

				} else {
					urlParams.delete('p');
				}

				if (this.currentSort != 'Name') {
					urlParams.set('s', this.currentSort);
				} else {
					urlParams.delete('s');
				}

				if (this.currentSortDir != 'asc') {
					urlParams.set('d', this.currentSortDir);
				} else {
					urlParams.delete('d');
				}

				if (this.currentSearch != '') {
					urlParams.set('q', this.currentSearch);

				} else {
					urlParams.delete('q');
				}

				var newurl =
					window.location.protocol +
					'//' +
					window.location.host +
					window.location.pathname +
					'?' +
					urlParams;
				window.history.pushState({ path: newurl }, '', newurl);

			}
		},

		clearSearch() {
			if (this.searchFlag) {
				this.currentSearch = '';
				this.searchFlag = false;
				this.resetPaging();
				this.fetchContacts();
			}
		},

		searchContacts() {
			if (this.currentSearch != '') {
				this.resetPaging();

				ContactService.search(this.currentSearch).then((response) => {
					Object.assign(
						this.paging,
						JSON.parse(response.headers['paging-headers'])
					);

					this.contacts = response.data;

					this.urlPushState();
					
					this.searchFlag = true;
				});
			}
		},

		fetchContacts() {
			ContactService.getPaged(
				this.paging.pageSize,
				this.paging.currentPage,
				this.currentSort,
				this.currentSortDir
			)
				.then((response) => {
					Object.assign(
						this.paging,
						JSON.parse(response.headers['paging-headers'])
					);

					this.contacts = response.data;

					this.urlPushState();

				})
				.catch((error) => {
					console.log('not authorized');
				});
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/contact/contact-list.vue